import { render, staticRenderFns } from "./ProductListingItemImage.vue?vue&type=template&id=42ff8110"
import script from "./ProductListingItemImage.vue?vue&type=script&lang=js"
export * from "./ProductListingItemImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports